/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class AccountGroupDialog extends SiteEntityDialog<AccountGroupRow, any> {
        protected getFormKey() { return AccountGroupForm.formKey; }
        protected getIdProperty() { return AccountGroupRow.idProperty; }
        protected getLocalTextPrefix() { return AccountGroupRow.localTextPrefix; }
        protected getNameProperty() { return AccountGroupRow.nameProperty; }
        protected getService() { return AccountGroupService.baseUrl; }

        protected form = new AccountGroupForm(this.idPrefix);

    }
}